import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/react';
import { createContext, ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

type Context = {
  selectedQuoteVariantId: number | null;
  setSelectedQuoteVariantId: (id: number | null) => void;
  noValidQuoteVariants: boolean;
  setNoValidQuoteVariants: (val: boolean) => void;

  modalDisclosure: UseDisclosureReturn;
};

export const SelectedQuoteVariantContext = createContext({} as Context);

type Props = {
  children: ReactNode;
  defaultSelectedQuoteVariantId?: number | null;
};

export const SelectedQuoteVariantProvider = ({ children, defaultSelectedQuoteVariantId }: Props) => {
  const modalDisclosure = useDisclosure();

  const params = useParams();
  const [selectedQuoteVariantId, setSelectedQuoteVariantId] = useState(
    params.quoteVariantId ? Number(params.quoteVariantId) : defaultSelectedQuoteVariantId || null,
  );
  const [noValidQuoteVariants, setNoValidQuoteVariants] = useState(false);

  // Update the URL when defaultSelectedQuoteVariantId changes
  useEffect(() => {
    if (defaultSelectedQuoteVariantId) {
      setSelectedQuoteVariantId(defaultSelectedQuoteVariantId);
    }
  }, [defaultSelectedQuoteVariantId]);

  return (
    <SelectedQuoteVariantContext.Provider
      value={{
        selectedQuoteVariantId,
        setSelectedQuoteVariantId,
        noValidQuoteVariants,
        setNoValidQuoteVariants,
        modalDisclosure,
      }}
    >
      {children}
    </SelectedQuoteVariantContext.Provider>
  );
};
